import { Cross } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type TooltipProps = {
  text: string | React.ReactNode;
  dismiss: () => void;
};

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
  gap: 8px;
  width: 298px;
`;

const TooltipHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledCross = styled(Cross)`
  fill: ${cbSemanticCssVars.textTertiary};
  width: 10px;
  cursor: pointer;
`;

const Tooltip = ({ text, dismiss }: TooltipProps) => {
  return (
    <TooltipContainer>
      <TooltipHeader>
        <Tag variant="blue">
          <FormattedMessage id="navigation.new" />
        </Tag>
        <StyledCross onClick={dismiss} />
      </TooltipHeader>
      <Typography.Body3>{text}</Typography.Body3>
    </TooltipContainer>
  );
};

export default Tooltip;
